// extracted by mini-css-extract-plugin
module.exports = {"card":"Cuotas__card__1iuqg","cuotas":"Cuotas__cuotas__1vSuy","banner":"Cuotas__banner__3h8GE","justificado":"Cuotas__justificado__3cKI5"};